import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

export interface OrderDetailsShippingMentInfoStyles {
    titleText?: TypographyProps;
    heading?: TypographyProps;
    description?: TypographyProps;
    wrapper?: InjectableCss;
    link?: InjectableCss;
    errorText?: InjectableCss;
}

export const shippingMentStyles: OrderDetailsShippingMentInfoStyles = {
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            font-size: 30px;
            padding-top: 10px;
        `,
    },
    heading: {
        css: css`
            font-weight: bold;
        `,
    },
    link: {
        css: css`
            text-decoration: underline;
            text-decoration-color: #0074b9;
        `,
    },
    errorText: {
        css: css`
            color: red;
            font-size: 18px;
        `,
    },
};

const styles = shippingMentStyles;

const OrderDetailsShipmentInfo: React.FunctionComponent = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    const { shipDate, trackingNumber, shipper, errorMessage } = order.properties || {};

    const noShipmentInfo = !shipDate && !trackingNumber && !shipper && !errorMessage;
    if (noShipmentInfo) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            {errorMessage && (
                <StyledWrapper>
                    <Typography {...styles.errorText}>{errorMessage}</Typography>
                </StyledWrapper>
            )}
            {shipDate && trackingNumber && shipper && (
                <StyledWrapper>
                    <Typography {...styles.titleText}>{translate("Shipment Info")}</Typography>
                    <StyledWrapper>
                        <Typography {...styles.heading}>{translate("Shipping Date: ")}</Typography>
                        <Typography {...styles.description}>{order?.properties?.shipDate}</Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography {...styles.heading}>{translate("Tracking #: ")}</Typography>
                        <Typography {...styles.description}>{order?.properties?.trackingNumber}</Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography {...styles.heading}>{translate("Shipper: ")}</Typography>
                        <Typography {...styles.description}>{order?.properties?.shipper}</Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Link
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=${order?.properties?.trackingNumber}`}
                            {...styles.link}
                        >
                            Track your order
                        </Link>
                    </StyledWrapper>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsShipmentInfo,
    definition: {
        allowedContexts: ["OrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
